import gql from 'graphql-tag';
import * as chat from './chat';
import * as user from './user';

export const message = gql`
  fragment ThreadMessage on ThreadMessage {
    id
    # Note(fant): we need to query senderId,
    # otherwise sender will fail... #schemastitching
    senderId
    sender {
      ...ShortUser
    }
    type
    subType
    content
    createdAt
    editedAt
    urgent: isImportant
    sentBySMS: fromSms
    meta: legacyMeta {
      ...ChatMessageMeta
    }
  }

  ${chat.messageMeta}
  ${user.short}
`;

export const memberships = gql`
  fragment ThreadWithMembershipsAndMessageCount on Thread {
    id
    messageCount
    memberships: threadMemberships {
      readMessageCount
      messagesViewedAt
      user {
        ...ShortUser
      }
    }
  }

  ${user.short}
`;

export const thread = gql`
  fragment Thread on Thread {
    id
    messages {
      ...ThreadMessage
    }
    ...ThreadWithMembershipsAndMessageCount
  }

  ${message}
  ${memberships}
`;
